export default __webpack_public_path__ + "static/media/PB.754473c2.jpg";